module.exports = __webpack_public_path__ + "static/Kajoban.db6e11d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Kajoban.jpg
// module id = 1303
// module chunks = 137408898365125